import { useEffect, useRef } from 'react';

export default (i18n, language) => {
  // Track the ref to skip the change on first render.
  const ref = useRef(true);

  useEffect(() => {
    // If this is the first render, skip it.
    if (ref.current) {
      ref.current = false;
      return;
    }

    i18n.changeLanguage(language);
  }, [language]); // eslint-disable-line react-hooks/exhaustive-deps
};
